import React from "react";
import Image from "react-bootstrap/Image";
import content from "../../includes/content";
import { getAssetURL } from "../../utils";
import "../CertAnimation/animation.css";

const certVersion = process.env.REACT_APP_CERTIFICATE_NAME;

export const FacebookCard = ({ loan }) => {
  return (
    <div className={certVersion}>
      <div className="facebook">
        <div className="top"></div>
        <div className="banner">
          <img className="profile" src={getAssetURL("male.png")} alt="" />
        </div>
        <div className="content">
          <div className="details">
            <img className="profile" src={getAssetURL("male.png")} alt="" />
            <strong>{loan?.borrowerName || loan?.borrowerHeaderLine}</strong>
            <strong>Credit Approved</strong>
            <p>Just now - &#127758;</p>
          </div>
          <div className="comment">
            <p>
              <strong>{loan?.borrowerName || loan?.borrowerHeaderLine}</strong>{" "}
              {content.postTagline(loan)}
            </p>
          </div>
          <div className="certificate-content">
            <p className="content-text"> {content.postDescription}</p>
            <Image
              src={content.facebookPostImage}
              className="certificate"
              fluid
            />
          </div>
        </div>
        <div className="bottom"></div>
      </div>
    </div>
  );
};
export const InstagramCard = ({ loan }) => {
  return (
    <div className={certVersion}>
      <div className="carousel__image instagram">
        <div className="profile__image"></div>
        <div className="profile__box">
          <div className="profile__image"></div>
          <span className="profile__name">
            {loan?.borrowerName || loan?.borrowerHeaderLine}
          </span>
        </div>
        <div className="cert__box">
          <Image
            src={content.instagramPostImage}
            className="instagram-cert"
            fluid
          />
        </div>
        <p className="post-text"> {content.postDescription}</p>
        <div className="description__box">
          <span className="profile__name">
            {loan?.borrowerName || loan?.borrowerHeaderLine}
          </span>
          <span className="descrition__text">{content.postTagline(loan)}</span>
          {/* <span className="description__more">...more</span> */}
        </div>
      </div>
    </div>
  );
};
export const LinkedInCard = ({ loan }) => {
  return (
    <div className={certVersion}>
      <div className="carousel__image linkedin">
        <div className="profile__image"></div>
        <div className="profile__header">
          <div className="profile__image"></div>
          <div className="profile__name">
            <strong>{loan?.borrowerName || loan?.borrowerHeaderLine}</strong>
          </div>
          <div className="social__icon"></div>
          <span className="following__dot">&bull;</span>
          <div className="following__text">following</div>
        </div>
        <p className="content-text">{content.postTagline(loan)}</p>
        <div className="cert__box">
          <p className="post-text"> {content.postDescription}</p>
          <Image
            src={content.instagramPostImage}
            className="linkedin-cert"
            fluid
          />
        </div>
      </div>
    </div>
  );
};
export const XCard = ({ loan }) => {
  return (
    <div className={certVersion}>
      <div className="twitter">
        <div className="top">
          <img className="profile" src={getAssetURL("male.png")} alt="" />
        </div>
        <div className="content">
          <div className="details">
            <img className="profile" src={getAssetURL("male.png")} alt="" />
            <small>
              <b>&#10084;</b> Sun West
            </small>
            <br />
            <p>{loan?.borrowerName || loan?.borrowerHeaderLine}</p>
          </div>
          <div className="comment">
            <p>{content.postTagline(loan)}</p>
          </div>
          <div className="wrapper">
            <p className="content-text"> {content.postDescription}</p>
            <Image src={content.xPostImage} className="certificate" fluid />
          </div>
        </div>
        <div className="bottom"></div>
      </div>
    </div>
  );
};
